import { useEffect, useRef, useState } from 'react';
import API from '@/lib/api';
import { DEFAULT_SHORTCUTS } from '@/lib/sidebarShortcuts';

export const useShortcutPreferences = user => {
  const context = user?._id ? `${user._id}:${user.verkoper_id || 'owner'}` : '';
  const [state, setState] = useState({ context: '', keys: DEFAULT_SHORTCUTS, revision: 0, status: 'loading', error: '' });
  const [attempt, setAttempt] = useState(0);
  const live = useRef(null), locked = useRef(false), failed = useRef(null);
  useEffect(() => {
    const current = { context };
    live.current = current; locked.current = false; failed.current = null;
    setState({ context, keys: DEFAULT_SHORTCUTS, revision: 0, status: 'loading', error: '' });
    if (!context) return;
    API.get('/voorkeuren/snelknoppen', { noCache: true, timeout: 10000 }).then(({ data }) => {
      if (live.current === current) setState({ ...data, context, status: 'ready', error: '' });
    }).catch(() => {
      if (live.current === current) setState(s => ({ ...s, status: 'load-error', error: 'Snelknoppen niet geladen.' }));
    });
    return () => { if (live.current === current) live.current = null; };
  }, [context, attempt]);

  const save = async keys => {
    if (locked.current || state.context !== context || !['ready', 'saved', 'save-error'].includes(state.status)) return;
    const current = live.current, previous = state.keys;
    locked.current = true;
    setState(s => ({ ...s, keys, status: 'saving', error: '' }));
    try {
      const { data } = await API.put('/voorkeuren/snelknoppen', { context, revision: state.revision, keys }, { timeout: 10000 });
      if (live.current !== current) return;
      failed.current = null;
      setState({ ...data, context, status: 'saved', error: '' });
    } catch (error) {
      if (live.current !== current) return;
      const conflict = error.response?.status === 409;
      failed.current = conflict ? null : keys;
      setState(s => ({ ...s, keys: previous, status: conflict ? 'load-error' : 'save-error',
        error: conflict ? 'Snelknoppen elders gewijzigd. Laad opnieuw.' : 'Niet bewaard. Vorige snelknoppen hersteld.' }));
    } finally { if (live.current === current) locked.current = false; }
  };
  const current = state.context === context ? state : { keys: DEFAULT_SHORTCUTS, status: 'loading', error: '' };
  return { ...current, ready: ['ready', 'saved', 'save-error'].includes(current.status), save,
    reset: () => save([...DEFAULT_SHORTCUTS]), retry: () => failed.current ? save(failed.current) : setAttempt(v => v + 1) };
};